document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".bestsellers__slider").forEach(function (slider) {
    const splide = new Splide(slider, {
      type: "loop",
      gap: "40px",
      arrows: true,
      drag: false,
      perPage: 3,
      perMove: 1,
      arrowPath:
        "M15 12.35L22.211 20L15 27.65L17.22 30L26.67 20L17.22 10L15 12.35Z",
      breakpoints: {
        750: {
          type: "loop",
          gap: "16px",
          fixedWidth: "320px",
          arrows: false,
          padding: { right: 24 },
        },
        990: {
          perPage: 2,
        },
        1200: {
          perPage: 3,
        },
      },
    });

    // Handle overflow - hide arrows when not enough slides
    splide.on("overflow", function (isOverflow) {
      splide.options = {
        arrows: isOverflow,
        pagination: false,
        drag: isOverflow,
      };
    });

    splide.mount();
  });
});
